import { render, staticRenderFns } from "./product-capacity.vue?vue&type=template&id=5c5204ac&scoped=true"
import script from "./product-capacity.vue?vue&type=script&lang=js"
export * from "./product-capacity.vue?vue&type=script&lang=js"
import style0 from "./product-capacity.vue?vue&type=style&index=0&id=5c5204ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5204ac",
  null
  
)

export default component.exports